import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Export from '../../Assets/Icons/Icon_Color_Export.png';
import Icon_Color_Success from '../../Assets/Icons/Icon_Color_Success.png';
import Icon_Color_Reject from '../../Assets/Icons/Icon_Color_Reject.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useProgressor } from '../../Contexts/Context_Progressor';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useReporting } from '../../Contexts/Context_Reporter';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';

export default function Subwindow_Modal_Report_Export_Processing({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Report_Type, Report_Output_Type, Report_Output_Progress } = useReporting();
    const { Confirmer_Respond } = useStatus();
    const { Progress } = useProgressor();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const [FileName, FileName_Set] = useState("Document");
    const Confirm = async () => {
        UI.Subwindows_Close("Window_Report_Export_Processing")
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_Report_Export");
    }


    return (
        <ui-subwindow Type='Modal' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                {Progress?.State === "Processing" ?
                    <>
                        <div className='Subwindow_Content_Icon'>
                            <img src={Icon_Color_Export} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                        </div>
                        <h2 className='General_Title' style={{ textAlign: "center" }}>
                            Exporting {Report_Output_Type === "PDF" ?
                                "document as a PDF"
                                :
                                Report_Output_Type === "Image" ?
                                    "document as image(s)"
                                    :
                                    ""
                            }
                        </h2>
                        <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "5px", marginBottom: "10px" }}>
                            Processing your document. This may take a while. Don't exit or refresh this screen.
                        </p>
                        <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "5px", marginBottom: "10px" }}>
                            {Progress?.Count_Current}/{Progress?.Count_Total} ({Math.round(Progress?.Percent_Current)}%)
                        </p>
                    </>
                    : Progress?.State === "Success" ?
                        <>
                            <div className='Subwindow_Content_Icon'>
                                <img src={Icon_Color_Success} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                            </div>
                            <h2 className='General_Title' style={{ textAlign: "center" }}>
                                File exported successfully.
                            </h2>
                            <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "5px", marginBottom: "10px" }}>
                                You may close this dialog.
                            </p>
                        </>
                        :
                        <>
                            <div className='Subwindow_Content_Icon'>
                                <img src={Icon_Color_Reject} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                            </div>
                            <h2 className='General_Title' style={{ textAlign: "center" }}>
                                An error occured.
                            </h2>
                            <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "5px", marginBottom: "10px" }}>
                                Please try again.
                            </p>
                        </>
                }


            </ui-subwindow-content>
            <ui-subwindow-controls>
                {Progress?.State !== "Processing" ?
                    <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                        Close
                    </button>
                    :
                    ""
                }

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
